module.exports = __webpack_public_path__ + "icon.png?a02c5ea91befbb6395a91a0e9239b7fd";